// Shared profile display formatters — used by the edit preview mapper, the
// play-profile mapper, and HeightInput. Single source so the formats never drift.

const MONTH_NAMES: ReadonlyArray<string> = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/** Format total inches as `5'11"`. Returns '' for 0 / null / undefined. */
export const formatHeight = (totalInches?: number | null): string => {
  if (!totalInches || totalInches <= 0) return ''
  const ft = Math.floor(totalInches / 12)
  const inches = totalInches % 12
  return `${ft}'${inches}"`
}

/** Age in whole years from a Date or ISO string; null if missing/invalid. */
export const computeAge = (dob?: Date | string | null): number | null => {
  if (!dob) return null
  const d = dob instanceof Date ? dob : new Date(dob)
  if (isNaN(d.getTime())) return null
  const today = new Date()
  let age = today.getFullYear() - d.getFullYear()
  const m = today.getMonth() - d.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < d.getDate())) age -= 1
  if (age < 0) return null
  return age
}

/** Format a Date/ISO as 'Apr 2026'. Falls back to the current month. */
export const formatMonthYear = (date?: Date | string | null): string => {
  let d = !date ? new Date() : date instanceof Date ? date : new Date(date)
  if (isNaN(d.getTime())) d = new Date()
  return `${MONTH_NAMES[d.getMonth()]} ${d.getFullYear()}`
}
